<template>
    <div class="order-confirmation">
        <img src="@/assets/images/confirmed.png" alt="Zamówienie potwierdzone" class="confirmation-image" />
        <h1 class="confirmation-title">Zajrzyj do swojej skrzynki!</h1>
        <p class="confirmation-text">
            Już tylko jedno kliknięcie dzieli Cię od złożenia zamówienia!
        </p>
        <router-link to="/" class="confirmation-button">Wróć na stronę główną</router-link>
    </div>
</template>

<script>
export default {
    name: 'OrderConfirmation',
    props: {
        orderId: {
            type: [Number, String],
            default: null
        }
    }
}
</script>

<style scoped lang="scss">
.order-confirmation {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    background-color: $color-background;
    color: $color-text;
    text-align: center;
    min-height: 100vh;
}

.confirmation-image {
    max-width: 420px;
    width: 100%;
    margin-bottom: 24px;
}

.confirmation-title {
    font-size: 1.6rem;
    font-weight: 900;
    margin-bottom: 12px;
    color: $color-primary-dark;
    -webkit-text-stroke: 0.5px $color-primary-dark;
}

.confirmation-text {
    font-size: 1.15rem;
    color: $color-text-light;
    margin-bottom: 60px;
    line-height: 1.6;
}

.confirmation-button {
    display: inline-block;
    padding: 12px 28px;
    background-color: $color-primary;
    color: $color-white;
    border-radius: 8px;
    text-decoration: none;
    transition: all 0.2s ease;

    &:hover {
        background-color: $color-primary-dark;
    }
}
</style>